"use client";

import { useContent } from "@/hooks/useContent";
import type { Bilingual, Locale } from "@/types/home";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { useLocale } from "next-intl";

interface ContactContent {
  email: string;
  phones: string[];
  whatsapp: string;
  address: Bilingual;
}

/** Contact quick-lines + office card, driven by panel-managed content. */
export default function ContactInfo() {
  const locale = useLocale() as Locale;
  const ar = locale === "ar";
  const { data } = useContent<ContactContent>("contact");

  const email = data?.email ?? "info@tahawer.com";
  const phones = data?.phones ?? [];

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        {phones.map((p, i) => (
          <a key={i} href={`tel:${p.replace(/\s+/g, "")}`} dir="ltr" className="flex items-center gap-3 text-ash transition-colors hover:text-accent dark:text-white">
            <Phone className="h-5 w-5 text-accent" />
            {p}
          </a>
        ))}
        <a href={`mailto:${email}`} className="flex items-center gap-3 text-ash transition-colors hover:text-accent dark:text-white">
          <Mail className="h-5 w-5 text-accent" />
          {email}
        </a>
        <span className="flex items-center gap-3 text-ash/60 dark:text-white/60">
          <Clock className="h-5 w-5 text-accent" />
          {ar ? "السبت – الخميس · ٩ص – ٦م" : "Sat – Thu · 9am – 6pm"}
        </span>
      </div>

      {data?.address && (
        <div className="border border-black/10 p-5 dark:border-white/10">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-accent">
            <MapPin className="h-4 w-4" />
            {ar ? "المقر الرئيسي" : "Headquarters"}
          </div>
          <p className="mt-2 text-sm text-ash/70 dark:text-white/70">{data.address[locale]}</p>
          {phones[0] && <p className="mt-1 text-sm text-ash dark:text-white" dir="ltr">{phones[0]}</p>}
        </div>
      )}
    </div>
  );
}
